<template lang="pug">
.FormLogin.login-form.login-view
  .login-form__social
    AuthSocialButtons(
      :reset-error="sendCount",
      @success="onSuccess",
      @click="onClick",
    )
  BaseForm(
    :model="model",
    keep-loading-send-on-success,
    honeypot
  )
    .login-form__or-arrow
      h6.login-form__or-arrow-title or
    div.login-form__fields
      BaseFormGroup.login-form__field(
        name="email",
        label="Email",
        placeholder="Email Address"
        :model="model",
        autofocus
      )
      .password-group
        BaseFormPasswordGroup.login-form__field(
          name="password",
          label="Password",
          placeholder="Password (min. 8 characters)"
          :model="model",
          visible-show-password-icon
          autocomplete="off",
          :visible-progress-liner="false"
        )
        .forgot-password
          router-link.link-2.small-link(
            to="/reset-password"
            tabindex="1"
          ) Forgot password
      BaseNotificationInline.login-form__notification(:value="model.__error__")
      BaseFormButton.login-form__button(
        block,
        color="primary",
        @click.prevent="send",
        type="submit",
        large,
      )
        span.svg-icon-container
          SharpEnvelopeIcon.svg-icon.upload-icon.base-btn__left-icon
        | Log In with Email
      .login-form__signup
        p.login-form__signup-text.small-text Don’t have an account?
        BaseButton(
          large,
          color="transparent",
          tag="router-link"
          :to="isSignUpRedirect ? `/sign-up?redirect=${this.onSignUpRedirect}` : '/sign-up'"
          tabindex="1"
        ) Sign Up
</template>

<script>
import { mapActions } from 'vuex';
import analytics from 'Analytics';
import LoginAuthModel from 'Models/LoginAuthModel';
import { FormBeforeSendError } from 'Classes';
import formHandlingMixin from 'Helpers/mixins/formHandlingMixin';
import AuthSocialButtons from 'Components/AuthSocialButtons/AuthSocialButtons';
import BaseSpinner from 'Components/Base/BaseSpinner';
import BaseForm from 'Components/Base/BaseForm';
import BaseFormButton from 'Components/Base/BaseFormButton';
import BaseFormGroup from 'Components/Base/BaseFormGroup';
import BaseNotificationInline from 'Components/Base/BaseNotificationInline';
import BaseFormPasswordGroup from 'Components/Base/BaseFormPasswordGroup';
import BaseButton from 'Components/Base/BaseButton';
import SharpEnvelopeIcon from 'images/svg-icons/fa-envelope.svg?component';

export default {
  name: 'FormLogin',
  components: {
    BaseNotificationInline,
    BaseSpinner,
    AuthSocialButtons,
    BaseForm,
    BaseFormButton,
    BaseFormPasswordGroup,
    BaseFormGroup,
    BaseButton,
    SharpEnvelopeIcon,
  },
  mixins: [formHandlingMixin],
  props: {
    onSignUpRedirect: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: new LoginAuthModel(),
      sendCount: 0,
      loading: false,
    };
  },
  methods: {
    ...mapActions('login', [
      'setLoginData',
    ]),
    ...mapActions('profile', [
      'getProfileData',
    ]),
    ...mapActions('modal', [
      'closeModal',
    ]),
    async send() {
      this.sendCount += 1;
      try {
        const { userData, loginData } = await this.$_form_send();
        if (loginData.token) {
          await this.onSuccess({ loginData, userData });
        }
      } catch (error) {
        if (!(error instanceof FormBeforeSendError)) throw error;
      }
    },
    onClick() {
      this.model.__error__ = '';
    },
    async onSuccess({ loginData, userData }) {
      this.setLoginData(loginData);
      await this.getProfileData({ updateEmptyFieldsData: userData });
      // Register login on back end
      this.$emit('success', loginData);
      analytics.triggerUserLogin(userData);
    },
    isSignUpRedirect() {
      return Boolean(this.onSignUpRedirect);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.login-form
  overflow: hidden
  &__social
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    @media screen and (max-width: 576px)
      flex-direction: column
      justify-content: center
  &__or-arrow
    border-bottom: 1px solid $support_lightgray
    position: relative
    margin: 30px 0
  &__or-arrow-title
    position: absolute
    z-index: 2
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    background-color: $gray-10
    padding: 0 20px
    min-width: 15px
    color: $text_gray
  &__signup
    display: flex
    align-items: center
    justify-content: center
    margin-top: 12px
  &__signup-text
    color: $text_gray
    margin-bottom: 0
    margin-right: 16px
    +font(400)
  &__fields
    background-color: $white
    padding: 40px
    @media screen and (max-width: 576px)
      padding: 10px
    .v-btn
      margin-top: 5px
    .password-group
      position: relative
      margin-bottom: 6px
      ::v-deep .password-group__field
        margin-bottom: 0
        .base-form-group--error
          margin-bottom: 50px
      .forgot-password
        display: flex
  &__notification
    margin-top: 12px
  &__button
    margin-top: 40px
    letter-spacing: 0.3px
    @media screen and (max-width: 576px)
      margin-top: 35px
    .svg-icon-container
      display: flex
    .svg-icon
      width: inherit
      height: 25px
</style>
